import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { useState } from "react";
import { useCategoriaParceiro } from "core/features/parceiros/hooks/useCategoriaParceiro";

export interface SelectCategoriaParceiroProps<T = any>
  extends SelectBaseAntdProps<T> {
  estadoId?: string | null;
}

function SelectCategoriaParceiro({ ...rest }: SelectCategoriaParceiroProps) {
  const [search, setSearch] = useState<string>();
  const { isLoading, data } = useCategoriaParceiro();

  return (
    <SelectBaseAntd
      disabled={isLoading}
      loading={isLoading}
      size="large"
      placeholder="Categoria"
      allowClear
      showSearch
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectCategoriaParceiro;
